// src/components/fix-actions/fix-actions-utils.ts

// Helper function to get impact level colors
export const getImpactColors = (level: string) => {
  switch (level) {
    case "High":
      return {
        bg: "var(--success-bg)",
        text: "var(--success-text)",
        border: "var(--success-border)",
      };
    case "Medium":
      return {
        bg: "var(--info-bg)",
        text: "var(--signal-blue)",
        border: "var(--info-border)",
      };
    case "Low":
      return {
        bg: "var(--muted)",
        text: "var(--muted-foreground)",
        border: "var(--border)",
      };
    default:
      return {
        bg: "var(--muted)",
        text: "var(--muted-foreground)",
        border: "var(--border)",
      };
  }
};

// Helper function to get effort level colors
export const getEffortColors = (level: string) => {
  switch (level) {
    case "Low":
      return {
        bg: "var(--success-bg)",
        text: "var(--success-text)",
        border: "var(--success-border)",
      };
    case "Medium":
      return {
        bg: "var(--info-bg)",
        text: "var(--signal-blue)",
        border: "var(--info-border)",
      };
    case "High":
      return {
        bg: "var(--error-bg)",
        text: "var(--error-text)",
        border: "var(--error-border)",
      };
    default:
      return {
        bg: "var(--muted)",
        text: "var(--muted-foreground)",
        border: "var(--border)",
      };
  }
};

export function formatPriorityUpdatedAt(value?: string | null): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);

  // Similar to: "January 5, 2026, 2:47 PM"
  return d.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
